export default __webpack_public_path__ + "static/img31h-8f83c9d0f20301d4d1a96a04a114dc49.jpg";